import { IOnInit } from "angular";

export class ContractInstanceNotesComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  $onInit() {}
}
